import Header from "../header";
import Footer from "../footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { fetchLoanById } from "apiCalls/applyClaimService";
import { useLanguage } from "context/LanguageContext";

function LoanDetails(){
    const { state } = useLocation();
    const navigate = useNavigate();
    const { t } = useLanguage();
    const claimType = state?.claimType;
    const aadhaar = state?.aadhaar?.replace(/\s+/g, "") || "";
    const aadhaarLoans = state?.loans || [];
    const [search, setSearch] = useState("");
    const [loadingLoanId, setLoadingLoanId] = useState(null);
    const [loanError, setLoanError] = useState("");

    const filtered = aadhaarLoans.filter(loan => {
        const q = search.toLowerCase().trim();
        if (!q) return true;
        return (
            loan.name?.toLowerCase().startsWith(q) ||
            loan.current_loan_number?.toLowerCase().startsWith(q)
        );
    });

    function formatDate(iso) {
        if (!iso) return "";
        const d = new Date(iso);
        if (isNaN(d)) return iso;
        return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
    }

    async function handleSelectLoan(loan) {
        setLoanError("");
        setLoadingLoanId(loan.id);
        try {
            const res = await fetchLoanById(loan.id);
            if (res.status !== "success") {
                setLoanError(res.message || t.fetchLoanError);
                return;
            }
            const d = res.data;
            const primaryMember = d.members?.find(m => m.primary_loanee) || {};
            const addressBook = d.society_branch?.society?.address_book;
            const societyAddress = [addressBook?.building_name, addressBook?.street, addressBook?.taluk?.name, addressBook?.district?.name].filter(Boolean).join(", ");
            const normalizedLoan = {
                name: d.name,
                loanNo: d.current_loan_number,
                amount: d.sanctioned_amount,
                society: d.society_branch?.society?.name || "",
                societyAddress: societyAddress,
                membership: primaryMember.society_membership_number || "",
                mobile: primaryMember.phone_number || "",
                dob: formatDate(primaryMember.date_of_birth),
                birthCertificateNumber: primaryMember.birth_certificate_number || "",
                aadhaar: aadhaar,
            };
            if (claimType === "disease") {
                navigate("/diseaseClaim", { state: { loan: normalizedLoan, freshClaim: true } });
            } else {
                navigate("/deathClaim", { state: { loan: normalizedLoan, freshClaim: true } });
            }
        } catch (err) {
            setLoanError(err?.message || t.fetchLoanErrorRetry);
        } finally {
            setLoadingLoanId(null);
        }
    }

    const btnLabel = claimType === "disease" ? t.diseaseClaimTitle : t.deathClaimTitle;

    return(
        <>
        <Header/>

                {/*==== Scroll up and prograss start ==== */}
    <div id="scrollUp">
        <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
            <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#fff"></path>
        </svg>
        <svg className="scrollprogress" width="40" height="40">
            <circle className="progress-circle" cx="20" cy="20" r="18" strokeWidth="2" fill="none" stroke="#fff" strokeDasharray="113.1" strokeDashoffset="113.1"></circle>
        </svg>
    </div>
    {/* ==== Scroll up and prograss Ends ==== */}


    {/* ==== Account Creation Page Banner Section Start ==== */}
    <section className="rs-page-banner rs-faq-page-banner pt-30 pb-30 mt-140">
        <div className="container">
            <div className="row">
                <div className="col-lg-7">
                    <div className="rs-page-banner__content">
                        <h1 className="title">{t.selectActiveLoan}</h1>
                        <p>{t.selectActiveLoanSubtitle}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
     {/* ==== Account Creation Page Banner Section Ends ==== */}


     {/*-- ====Page Section Start ==== */}
    <section className="rs-faq-page pt-50 pb-120">
        <div className="container">

            <div className="row justify-content-center">
                <div className="col-lg-12">

                   {/* Loanee Info */}
                    {aadhaarLoans.length > 0 && (
                        <div className="row mb-4">
                            <div className="col-md-5">
                                <div className="d-flex gap-4">
                                    <div>
                                        <span className="text-muted small">{t.loaneeName}</span>
                                        <div className="fw-semibold" style={{ color: "#212529" }}>{aadhaarLoans[0].name}</div>
                                    </div>
                                    <div className="ps-4">
                                        <span className="text-muted small">{t.aadhaarNumber}</span>
                                        <div className="fw-semibold" style={{ color: "#212529" }}>
                                            {aadhaar.replace(/(\d{4})(\d{4})(\d{4})/, "$1 $2 $3")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                   {loanError && <div className="alert alert-danger py-2">{loanError}</div>}

                   {/*--search and filter -- */}
                    <div className="row">
                        <div className="col-md-5">
                            <div className="input-group">
                                <span className="input-group-text bg-white border-end-0">
                                    <i className="fa fa-search"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-start-0"
                                    placeholder={t.searchByNameOrLoan}
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                     {/*--search and filter-- */}

                    {/*--list-- */}
                    <div className="table-responsive mt-4">
                        <table className="table outer-border table-hover">
                            <thead>
                                <tr>
                                    <th>{t.societyName}</th>
                                    <th>{t.membershipNo}</th>
                                    <th>{t.loanNumber}</th>
                                    <th>{t.amount}</th>
                                    <th>{t.actions}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.length > 0 ? filtered.map((loan, i) => (
                                    <tr key={i}>
                                        <td style={{ maxWidth: "200px", wordBreak: "break-word", whiteSpace: "normal" }}>{loan.society_branch?.society?.name || "-"}</td>
                                        <td>{loan.members?.find(m => m.primary_loanee)?.society_membership_number || "-"}</td>
                                        <td>{loan.current_loan_number}</td>
                                        <td>{loan.sanctioned_amount}</td>
                                        <td><button type="button" className="btn btn-primary ms-2" onClick={() => handleSelectLoan(loan)} disabled={loadingLoanId !== null}>{loadingLoanId === loan.id ? t.loading : btnLabel}</button></td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted py-4">{t.noRecordsFound} "{search}"</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/*--list-- */}
                    <div className="row mt-4">
                        <div className="col-md-12 text-end">
                            <button className="btn btn-secondary me-3" onClick={() => navigate("/claimLoaneeIdentification")}><i className="fa fa-angle-left me-2"></i>{t.back}</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
    {/*-- ====Page Section Ends ==== -- */}

        <Footer/>
        </>
    )
}

export default LoanDetails